/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { Owner } from "../../../models/owner.model"
import { Sale } from "../../../models/sales.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { SALE_ENDPOINT } from "../sale.endpoint"

let tenantCollection: CollectionQuery
let tenantCountCollection: CollectionQuery
let ownersOfTenantCollection: CollectionQuery
let archivedTenantCollection: CollectionQuery
const saleQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getSale: builder.query<Sale, string>({
      query: (id: string) => ({
        url: `${SALE_ENDPOINT.detail}/${id}`,
        method: "get",
      }),
      providesTags: ["Sale"],
    }),

    getSales: builder.query<Collection<Sale>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${SALE_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Sales"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   SaleCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countSales: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${SALE_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Sales"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   SaleCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getOwnersOfSale: builder.query<Collection<Owner>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${SALE_ENDPOINT.getOwnersOfSale}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   ownersOfSaleCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getArchivedSale: builder.query<Sale, string>({
      query: (id: string) => ({
        url: `${SALE_ENDPOINT.archivedSale}/${id}`,
        method: "get",
      }),
      providesTags: ["Archived Sale"],
    }),

    getArchivedSales: builder.query<Collection<Sale>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${SALE_ENDPOINT.archivedSales}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Archived Sales"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   archivedSaleCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    createSale: builder.mutation<Sale, any>({
      query: (newData: any) => ({
        url: `${SALE_ENDPOINT.create}`,
        method: "post",
        data: newData,
        permissions: "manage-sales",
      }),
      invalidatesTags: ["Sales", "Count Sales"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    importSale: builder.mutation<Sale, { id?: string; file?: any }>({
      query: (newData: { id?: string; file?: any }) => ({
        url: `${SALE_ENDPOINT.import}/${newData.id}`,
        method: "post",
        data: newData?.file,
        permissions: "manage-sales",
      }),
      invalidatesTags: ["Sales", "Count Sales"],

      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateSale: builder.mutation<Sale, any>({
      query: (newData: any) => ({
        url: `${SALE_ENDPOINT.update}`,
        method: "put",
        data: newData,
        permission: "manage-sales",
      }),
      invalidatesTags: ["Sale", "Sales"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((tenant) => {
            //           if (tenant.id === data.id) return data
            //           else {
            //             return tenant
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    toggleSaleStatus: builder.mutation<Sale, string>({
      query: (id: string) => ({
        url: `${SALE_ENDPOINT.toggleStatus}/${id}`,
        method: "post",
        permission: "manage-sales",
      }),
      invalidatesTags: ["Sale", "Sales"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((tenant: Tenant) => {
            //           if (tenant.id === data.id) return data
            //           else {
            //             return tenant
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   saleQuery.util.updateQueryData("getTenant", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    archiveSale: builder.mutation<Sale, { id: string; reason: string }>({
      query: (data) => ({
        url: `${SALE_ENDPOINT.archive}`,
        method: "delete",
        data: data,
        permission: "manage-sales",
      }),
      invalidatesTags: ["Sale", "Sales"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((tenant) => {
            //         if (tenant.id === arg.id) {
            //           return data
            //         } else {
            //           return tenant
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getTenant",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getArchivedTenant",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully archived")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    deleteSale: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${SALE_ENDPOINT.delete}/${id}`,
        method: "delete",
        permission: "manage-sales",
      }),
      invalidatesTags: ["Sale", "Sales"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getArchivedTenants",
            //     archivedTenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter((tenant) => tenant.id !== id)
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    restoreSale: builder.mutation<Sale, string>({
      query: (id: string) => ({
        url: `${SALE_ENDPOINT.restore}/${id}`,
        method: "post",
        permission: "manage-sales",
      }),
      invalidatesTags: ["Sale", "Sales"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((tenant) => {
            //         if (tenant.id === id) {
            //           return data
            //         } else {
            //           return tenant
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   saleQuery.util.updateQueryData("getTenant", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   saleQuery.util.updateQueryData(
            //     "getArchivedTenant",
            //     id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully restored")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    removeSalesFile: builder.mutation<
      Sale,
      { saleId: string; filename: string }
    >({
      query: (data: { saleId: string; filename: string }) => ({
        url: `${SALE_ENDPOINT.removeFile}/${data.saleId}/${data.filename}`,
        method: "post",
        permission: "manage-sales",
      }),
      invalidatesTags: ["Sale", "Sales"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   leaseQuery.util.updateQueryData(
            //     "getRentIncreases",
            //     rentIncreaseCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter(
            //           (rentIncrease) => rentIncrease.id !== id,
            //         )
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
  }),
  overrideExisting: true,
})
export const {
  useLazyCountSalesQuery,
  useLazyGetArchivedSaleQuery,
  useLazyGetArchivedSalesQuery,
  useLazyGetOwnersOfSaleQuery,
  useLazyGetSaleQuery,
  useLazyGetSalesQuery,
  useCreateSaleMutation,
  useDeleteSaleMutation,
  useImportSaleMutation,
  useUpdateSaleMutation,
  useArchiveSaleMutation,
  useRestoreSaleMutation,
  useToggleSaleStatusMutation,
  useRemoveSalesFileMutation,
} = saleQuery
